import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { UniversalDialogForRouter } from 'console/dialogs/universal';
import { Z3KDashboardSettingsNavigation } from './navigation';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { useDashboardSettings } from './provider/types';
import { set_ui_settings } from 'console/redux/settings-actions';
import { DashboardSettingsRoutes } from './types';
import { useNavigateRoot, useNavigateTo } from 'shared/hooks/router';
import { SaveApplyButtons } from 'z3k-settings/layout/save-apply-buttons';
import { useAction } from 'shared/hooks/redux/hooks';
const medium_ui_styles = {
    width: 900,
    height: 700,
};
const content_sx = {
    ...(isMediumUI() && medium_ui_styles),
    overflow: 'hidden',
};
export const DashboardSettings = memo(function Z3KDashboardSettings() {
    const closeSettings = useNavigateRoot();
    const { dashboard_config } = useDashboardSettings();
    const setUISettings = useAction(set_ui_settings);
    const onApplyDashboardSettings = useCallback(() => {
        if (dashboard_config &&
            dashboard_config.devices &&
            dashboard_config.devices.length > 100) {
            return;
        }
        setUISettings({ dashboard_settings: dashboard_config });
    }, [dashboard_config]);
    const onSaveDashboardSettings = useCallback(() => {
        closeSettings();
        onApplyDashboardSettings();
    }, [dashboard_config]);
    const { state } = useLocation();
    const medium_ui_redirect = useNavigateTo(DashboardSettingsRoutes.devices);
    useEffect(() => {
        if (isMediumUI()) {
            medium_ui_redirect();
        }
    }, []);
    return (_jsx(UniversalDialogForRouter, { contentWithZeroPadding: true, maxWidth: "md", content_sx: content_sx, title: state?.title ?? 'Настройки панели', footer: _jsx(Box, { display: "flex", justifyContent: "flex-end", children: _jsx(SaveApplyButtons, { loading: false, disabled: false, onSave: onSaveDashboardSettings, onApply: onApplyDashboardSettings }) }), children: _jsxs(Box, { display: "grid", gridTemplateColumns: isMediumUI() ? '250px 1fr' : '1fr', width: "100%", height: "100%", overflow: "hidden", children: [isMediumUI() && _jsx(Z3KDashboardSettingsNavigation, {}), _jsx(Outlet, {})] }) }));
});
